import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "Cartonomie · L'index mondial des prix des cartes Pokémon";
const DEFAULT_DESC = "Track the price of every Pokémon card in every language. Real sales from eBay, Cardmarket, TCGPlayer, Mercari and more — organized by set.";

const EU_LANGS = ["en", "fr", "de", "es", "it"];

export default function Seo({ title, description, image, url, type = "website", keywords }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const t = title ? `${title} · Cartonomie` : DEFAULT_TITLE;
  const d = description || DEFAULT_DESC;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pathPart = location.pathname + location.search;
  const canonical = url || `${origin}${location.pathname}`;
  const currentLang = (i18n.language || "en").split("-")[0];

  // Build hreflang alternates — use ?lang= query for non-default languages
  const buildAlt = (lang) => {
    const hasQ = pathPart.includes("?");
    const cleaned = pathPart.replace(/([?&])lang=[^&]+(&|$)/g, (_, p1, p2) => (p2 === "&" ? p1 : ""));
    if (lang === "en") return `${origin}${cleaned.replace(/[?&]$/, "")}`;
    const sep = cleaned.includes("?") ? "&" : "?";
    return `${origin}${cleaned}${sep}lang=${lang}`;
  };

  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{t}</title>
      <meta name="description" content={d} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={currentLang === "en" ? "en_US" : `${currentLang}_${currentLang.toUpperCase()}`} />
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      {image && <meta name="twitter:image" content={image} />}
      <link rel="canonical" href={canonical} />
      {EU_LANGS.map((lang) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={buildAlt(lang)} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={buildAlt("en")} />
    </Helmet>
  );
}
